// Utility functions for icon sizing
import type { IconIntent, IconSize } from './Icon';

/** Mapping from semantic intent to the governed Tailwind colour class. */
export const ICON_INTENT_CLASSES: Record<IconIntent, string> = {
  default: 'text-text-muted',
  active: 'text-text-primary',
  muted: 'text-text-muted',
  primary: 'text-primary-600',
  success: 'text-status-success-foreground',
  warning: 'text-status-warning-foreground',
  danger: 'text-status-danger-foreground',
  info: 'text-primary-600',
} as const;

/**
 * Standardized icon sizing classes
 * Separated from the Icon component to avoid fast refresh issues
 */
export const getIconSizeClass = (_size: IconSize): string => {
  const sizeClasses: Record<IconSize, string> = {
    micro: 'w-2.5 h-2.5', // 10px - Micro indicators (radio-dot checkmarks)
    xxs: 'w-3.5 h-3.5', // 14px - Compact buttons, field labels
    xs: 'w-3 h-3',   // 12px - Use for very small contexts like badges or indicators
    sm: 'w-4 h-4',   // 16px - Use for small UI elements like inline buttons
    md: 'w-5 h-5',   // 20px - Default, use in most UI contexts
    lg: 'w-6 h-6',   // 24px - Use for slightly larger UI elements that need emphasis
    xl: 'w-7 h-7',   // 28px - Use for major UI elements that need prominence
  };

  return sizeClasses[_size];
};
